var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"select-input",attrs:{"items":_vm.items,"label":_vm.label,"rules":_vm.rules,"value":_vm.value,"item-text":_vm.itemText,"item-value":_vm.itemValue,"error-messages":_vm.errorMessages,"append-icon":"expand_more","menu-props":{ contentClass: 'select-content' }},on:{"input":_vm.onInput,"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }